var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BFE82D",
    d: "M6.27500816,0.593564629 C7.28636636,-0.197854916 8.71363393,-0.197854916 9.72502424,0.593564865 L14.941325,4.67541638 C15.6099336,5.19863801 16,5.99648739 16,6.84079687 L16,13.2410468 C16,14.7647273 14.7537476,16 13.2163009,16 L2.78369906,16 C1.24625238,16 0,14.7647273 0,13.2410468 L0,6.84079687 C0,5.99648472 0.390076552,5.19863654 1.05870715,4.67541632 Z M10.0062696,12.4706876 L5.99373041,12.4706876 C5.78593825,12.4706876 5.61755486,12.6375967 5.61755486,12.843328 C5.61755486,13.0490593 5.78593825,13.2159684 5.99373041,13.2159684 L10.0062696,13.2159684 C10.214041,13.2159684 10.3824451,13.049048 10.3824451,12.843328 C10.3824451,12.637608 10.214041,12.4706876 10.0062696,12.4706876 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home_active.34fbfd31e64fa8b21dbd52f946362285.svg";
export { ForwardRef as ReactComponent };